<template>
  <div class="niste-clan">
	<div>Trenutno u pripremi. Dolazi uskoro..</div>
	<router-link to="/">Povratak na početnu</router-link>
  </div>
</template>

<script>
export default {
	

}
</script>

<style>

</style>